export const Style = ({ colors = [] }) => (
  <g id="Estilo2_6_">
    <g>
      <g>
        <path
          id="SVGID_42_"
          style={{ fill: colors[0] }}
          d="M96.6,162l31.3-7.5l-8.4-35c-2.1-8.7-10.8-14-19.4-11.9l0,0 		c-8.7,2.1-14,10.8-11.9,19.4L96.6,162z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_91_"
            d="M96.6,162l31.3-7.5l-8.4-35c-2.1-8.7-10.8-14-19.4-11.9l0,0c-8.7,2.1-14,10.8-11.9,19.4L96.6,162z"
          />
        </defs>
        <clipPath id="SVGID_92_">
          <use xlinkHref="#SVGID_91_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_36_"
          gradientUnits="userSpaceOnUse"
          x1="128.2008"
          y1="333.6513"
          x2="138.0287"
          y2="333.6513"
          gradientTransform="matrix(0.9939 -0.1103 -0.1103 -0.9939 16.2546 494.1317)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>
        <path
          id="Multiply_11_"
          style={{
            opacity: '0.3',
            clipPath: 'url(#SVGID_92_)',
            fill: 'url(#Multiply_36_)',
            enableBackground: 'new'
          }}
          d=" 		M112.2,148.9c0.2,1.1,0.4,2.3,1.1,3.2c1,1.3,2.7,1.9,3.9,3c0.2,0.2,0.3,0.3,0.4,0.6c0,0.2-0.1,0.4-0.1,0.6 		c-1.3,3-4.4,5.1-7.7,5.3c-0.3,0-0.6,0-0.8-0.1c-0.2-0.2-0.3-0.5-0.4-0.8c-1.4-4.7-0.9-9.7,0-14.5c0.7-3.8,1.7-7.6,1.7-11.5 		C110.8,139.4,111.3,144.1,112.2,148.9z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          id="SVGID_44_"
          style={{ fill: colors[0] }}
          d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4 		c-2.6,1.1-1,3.9-0.2,6.6c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-4.1-26,4.4-86,4.4-86 		C113.1,113.2,112.6,109.3,109.8,108.3z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_93_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-4.1-26,4.4-86,4.4-86 			C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_94_">
          <use xlinkHref="#SVGID_93_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_37_"
          gradientUnits="userSpaceOnUse"
          x1="45.2941"
          y1="304.3146"
          x2="69.1263"
          y2="304.3146"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>
        <path
          id="Multiply_10_"
          style={{
            opacity: '0.3',
            clipPath: 'url(#SVGID_94_)',
            fill: 'url(#Multiply_37_)',
            enableBackground: 'new'
          }}
          d=" 		M56.6,145.6c-3.5,8.4-1.3,18.9,5.3,25.3c0.5,0.5,1,1,1.1,1.6c0,0.6-0.3,1.1-0.7,1.6c-1,1.2-2.2,2.3-3,3.7s-1.2,3.2-0.4,4.6 		c0.9,1.6,3.1,2.3,3.5,4.1c0.5,2.5-3,4.3-2.9,6.9c0,1.9,2,3.2,3.8,4c1.9,0.9,3.7,1.8,5.5,2.7c-0.3,0.8-1.5,0.5-2.3,0.8 		c-1,0.4-1,1.9-0.3,2.7c0.7,0.8,1.8,1.1,2.9,1.3c0.3,0.6-0.7,1-1.4,1c-5.1-0.1-10.2-0.2-15.3-0.4c-1.3,0-2.7-0.1-4-0.4 		c-0.4-0.1-0.8-0.3-1.1-0.6c-0.3-0.4-0.4-0.9-0.5-1.4c-1.5-13.4-1.9-27-1.2-40.5c0.1-1.2,0.1-2.4,0.5-3.6 		c0.3-1.1,0.9-2.2,1.6-3.1c2.1-3.2,5-5.9,8.4-7.7"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_95_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-4.1-26,4.4-86,4.4-86 			C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_96_">
          <use xlinkHref="#SVGID_95_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_38_"
          gradientUnits="userSpaceOnUse"
          x1="48.0564"
          y1="370.7416"
          x2="74.46"
          y2="370.7416"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>

        <path
          id="Multiply_12_"
          style={{
            opacity: '0.15',
            clipPath: 'url(#SVGID_96_)',
            fill: 'url(#Multiply_38_)',
            enableBackground: 'new'
          }}
          d=" 		M74.5,116c-7.2-1.6-14.6-3.9-19.8-9.1c-1.1-1.1-3.8-4.8-5.7-4.3c-2.8,0.7,1.9,4.2,2.7,4.9c4.1,3.4,8.9,5.9,14,7.2 		C68.5,115.5,71.5,115.9,74.5,116z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_97_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-4.1-26,4.4-86,4.4-86 			C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_98_">
          <use xlinkHref="#SVGID_97_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_39_"
          gradientUnits="userSpaceOnUse"
          x1="91.94"
          y1="372.86"
          x2="106.04"
          y2="372.86"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>

        <path
          id="Multiply_13_"
          style={{
            opacity: '0.15',
            clipPath: 'url(#SVGID_98_)',
            fill: 'url(#Multiply_39_)',
            enableBackground: 'new'
          }}
          d=" 		M102.9,101.5c1.1,0.4,2.2,1,3.1,1.7c-3.1,2.7-6.4,5.1-9.8,7.4c-1.3,0.8-2.8,1.9-4.3,2.2c0.2-0.9,1.7-1.6,2.4-2.2 		c1.1-0.9,2.1-1.8,3.2-2.8C99.5,105.9,101.3,103.8,102.9,101.5z"
        />
      </g>
    </g>
    <path
      style={{
        fill: 'none',
        stroke: '#000000',
        strokeWidth: '0.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10'
      }}
      d=" M107.5,159.4c0,0,2.1-16.2,2.9-26.3"
    />
    <path
      style={{ fill: colors[0] }}
      d="M51.5,164l-31.3-7.5l8.4-35c2.1-8.7,10.8-14,19.4-11.9l0,0c8.7,2.1,14,10.8,11.9,19.4L51.5,164z"
    />

    <polyline
      style={{
        fill: 'none',
        stroke: '#000000',
        strokeWidth: '0.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10'
      }}
      points=" 44.1,162.5 51.5,164 56.8,142.2 		"
    />
  </g>
)
